(function () {
  const SECTION_SELECTOR = "[data-base44-download]";
  const INIT_FLAG = "data-b44-initialized";

  function isIOSDevice() {
    return /iPad|iPhone|iPod/.test(window.navigator.userAgent || "");
  }

  function applyIOSCardOrder(section) {
    if (section.dataset.iosFirst !== "true" || !isIOSDevice()) {
      return;
    }

    const cardContainer = section.querySelector("[data-b44-cards]");
    if (!cardContainer) {
      return;
    }

    const androidCard = cardContainer.querySelector('[data-platform="android"]');
    const iosCard = cardContainer.querySelector('[data-platform="ios"]');

    if (androidCard && iosCard && cardContainer.firstElementChild !== iosCard) {
      cardContainer.insertBefore(iosCard, androidCard);
    }
  }

  function runReveal(section) {
    const revealElements = section.querySelectorAll("[data-b44-reveal]");

    revealElements.forEach((element) => {
      const delay = Number(element.getAttribute("data-b44-reveal-delay") || 0);
      element.style.setProperty("--b44-delay", `${delay}ms`);
      element.classList.remove("is-visible");

      window.setTimeout(() => {
        element.classList.add("is-visible");
      }, 10);
    });
  }

  function initSection(section) {
    if (!section || section.getAttribute(INIT_FLAG) === "true") {
      return;
    }

    section.setAttribute(INIT_FLAG, "true");
    applyIOSCardOrder(section);
    runReveal(section);
  }

  function initAll(root) {
    const scope = root || document;
    scope.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  function onSectionLoad(event) {
    initAll(event.target);
  }

  if (!window.__base44DownloadBindings) {
    window.__base44DownloadBindings = true;
    document.addEventListener("DOMContentLoaded", () => initAll(document));
    document.addEventListener("shopify:section:load", onSectionLoad);
  }

  initAll(document);
})();
